import * as Redux from 'redux';
import { ReduxPromiseAction, SimpleResponse } from '../app/app.types';
import { callApi } from '../util/ApiCaller';
import { AccountActionTypes } from './Types';
import * as ACCOUNT_ACTION_TYPES from './Constants';
import { pickAuthOrImpersonationToken } from '../util/token.util';

export const updateAccount: Redux.ActionCreator<
  ReduxPromiseAction<
    AccountActionTypes, SimpleResponse<{}>
  >
> = (
  firstName: string,
  lastName: string,
  email: string,
  password: string | undefined,
  phone: string,
  isImpersonating: boolean
): ReduxPromiseAction<AccountActionTypes, SimpleResponse<{}>> => ({
  type: isImpersonating ? ACCOUNT_ACTION_TYPES.IMPERSONATION_UPDATE_ACCOUNT : ACCOUNT_ACTION_TYPES.UPDATE_ACCOUNT,
  payload: callApi(
    process.env.REACT_APP_API + '/account',
    true,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: JSON.stringify({firstName, lastName, email, password, phone})
    }
  )
});



// WEBPACK FOOTER //
// ./src/account/Actions.tsx